const RootPath = window.g.baseUrl
const apis = {
  /* 外协入库异常 api */
  getOutsourceExceptionList: RootPath + 'plugin/outsource/exception/GetOutsourceExceptionList',
  delExceptionHandler: RootPath + 'plugin/outsource/exception/DelExceptionHandler',

  /* 半成品入库异常 api */
  getHalfInstoreExceptionList: RootPath + 'plugin/store/exception/GetHalfInstoreExceptionList',
  delHalfExceptionHandler: RootPath + 'plugin/store/exception/DelHalfExceptionHandler'
}

export default apis
